export const strengthExerciseCatalog = [
  { id: "back_squat", label: "Back squat", displacementM: 0.6 },
  { id: "front_squat", label: "Front squat", displacementM: 0.55 },
  { id: "deadlift", label: "Deadlift", displacementM: 0.5 },
  { id: "romanian_deadlift", label: "Romanian deadlift", displacementM: 0.45 },
  { id: "hip_thrust", label: "Hip thrust", displacementM: 0.35 },
  { id: "power_clean", label: "Power clean", displacementM: 0.65 },
  { id: "bench_press", label: "Bench press", displacementM: 0.5 },
  { id: "incline_bench_press", label: "Incline bench press", displacementM: 0.45 },
  { id: "dumbbell_bench_press", label: "Dumbbell bench press", displacementM: 0.5 },
  { id: "overhead_press", label: "Overhead press", displacementM: 0.45 },
  { id: "dumbbell_shoulder_press", label: "Dumbbell shoulder press", displacementM: 0.45 },
  { id: "barbell_row", label: "Barbell row", displacementM: 0.45 },
  { id: "dumbbell_row", label: "Dumbbell row", displacementM: 0.4 },
  {
    id: "pull_up",
    label: "Pull-up",
    displacementM: 0.4,
    usesBodyweight: true,
  },
  {
    id: "chin_up",
    label: "Chin-up",
    displacementM: 0.4,
    usesBodyweight: true,
  },
  {
    id: "dip",
    label: "Dip",
    displacementM: 0.35,
    usesBodyweight: true,
  },
  { id: "lat_pulldown", label: "Lat pulldown", displacementM: 0.5 },
  { id: "leg_press", label: "Leg press", displacementM: 0.6 },
  { id: "leg_extension", label: "Leg extension", displacementM: 0.35 },
  { id: "leg_curl", label: "Leg curl", displacementM: 0.35 },
  { id: "lunge", label: "Lunge", displacementM: 0.5 },
  { id: "calf_raise", label: "Calf raise", displacementM: 0.3 },
  { id: "chest_fly", label: "Chest fly", displacementM: 0.35 },
  { id: "lateral_raise", label: "Lateral raise", displacementM: 0.3 },
  { id: "biceps_curl", label: "Biceps curl", displacementM: 0.35 },
  { id: "triceps_pushdown", label: "Triceps pushdown", displacementM: 0.35 },
];

export const strengthExerciseById = strengthExerciseCatalog.reduce(
  (acc, exercise) => {
    acc[exercise.id] = exercise;
    return acc;
  },
  {}
);
